import { create } from "zustand";

const DEFAULT_TAB = 0

interface TabStore {
  tabs: Map<string, number>;
  setTab: (key: string, value: number) => void;
  getTab: (key: string) => number;
}

export const useTabsStore = create<TabStore>()((set, get) => ({
  tabs: new Map(),
  setTab: (key: string, value: number) => {
    set((state) => ({
        tabs: new Map(state.tabs).set(key, value)
    }))
  },
  getTab: (key: string) => {
    if (!get().tabs.has(key)) {
        return DEFAULT_TAB;
    }
    return get().tabs.get(key) as number
  }
}));
